import { getBase64Promise } from './conversions';

const MAX_SIDE = 1024;

// O backend recusa SVG (o container não tem imagick), então quem rasteriza é o
// navegador — a mesma conta que a vitrine faz antes de enviar.
const rasterizeSvg = dataUri =>
    new Promise((resolve, reject) => {
        const img = new window.Image();

        img.onload = () => {
            const width = img.naturalWidth || MAX_SIDE;
            const height = img.naturalHeight || MAX_SIDE;
            const scale = MAX_SIDE / Math.max(width, height);
            const canvas = document.createElement('canvas');

            canvas.width = Math.max(1, Math.round(width * scale));
            canvas.height = Math.max(1, Math.round(height * scale));
            canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);

            resolve(canvas.toDataURL('image/png'));
        };
        img.onerror = () => reject(new Error('Não foi possível ler o SVG. Tente exportar o logo em PNG.'));
        img.src = dataUri;
    });

export const LOGOTYPE_ACCEPT = 'image/png,image/jpeg,image/webp,image/svg+xml';

export const readLogotypeAsDataUri = async file => {
    const dataUri = await getBase64Promise(file);

    if (file.type === 'image/svg+xml' || file.type === 'image/svg') {
        return rasterizeSvg(dataUri);
    }

    return dataUri;
};
